module.exports = __webpack_public_path__ + "static/media/road-less.9bfc6f75.jpg";